import React, { useState, useEffect } from "react";
import HeaderLeft from "./HeaderLeft";
import { Link, useNavigate, Navigate } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import GetStorage from "../services/Storage";
import polygon from "../assets/images/Polygon 56.png";
import DownloadLink from "react-download-link";
import Modal from "react-bootstrap/Modal";
import { SpinnerCircular } from "spinners-react";
import Dropdown from "react-bootstrap/Dropdown";
import dots from "../assets/images/dots.svg";
import moment from "moment";
import { showToast } from "./ShowToast";
import { ToastContainer } from "react-toastify";
import { FaDownload, FaUpload } from "react-icons/fa";

function Work() {
  const token = GetStorage.get("xAuthToken");
  const [error, setError] = useState("");
  const [work, setWork] = useState([]);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const user = GetStorage.get("user");
    if (user.data.is_approved === 0) {
      navigate("/");
    }

    SamplePractice();
  }, []);
  const initialValues = {
    fileName: "",
  };

  const SamplePractice = async () => {
    setLoading(true);

    http
      .get(`api/analyst/work?token=${token}`)
      .then((res) => {
        console.log("response===>", res.data);
        setWork(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const handleChanges = (event) => {
    console.log("video url===>", event.target.files[0]);
    const val = event.target.files[0];
    setValues(val);
  };
  const [showModal, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [inputText, setInputText] = useState("");

  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const [value, setValues] = useState("0");
  const [message, setMessage] = useState("");

  const handleUpload = () => {
    if (value.type !== "video/mp4") {
      setError("Invalid file.");
      return;
    } else {
      setError("");
    }
    http
      .post(`api/analyst/s3video/evo?token=${token}`, {
        file_type: "video/mp4",
        file_name: inputText,
      })
      .then((res) => {
        console.log("response", res.data);
        const { url, key } = res.data;
        console.log(url, key);
        setUrl(key);
        fetch(url, {
          body: value,
          method: "PUT",
          headers: {
            "content-type": value.type,
            Accept: "*/*",
          },
        });
        handleClose();
        // navigate("/uploadNewPracticeVideo");
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };

  const WatchVideoCode = async (id, type) => {
    console.log("type ------->>>>", id, type);

    setLoading(true);

    http
      .get(`api/common/video_request?token=${token}`)
      .then((res) => {
        console.log("response ------->>>>", res.data);

        navigate(`/otpLogs/${id}/${type}`);

        // setLocker(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const downloadVideos = async (videoURL) => {
    setLoading(true)
    try {

      // Fetch the video file from the URL
      const response = await fetch(videoURL);

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      // Get the video file as a Blob
      const blob = await response.blob();

      // Create a URL for the Blob object
      const url = window.URL.createObjectURL(blob);

      // Create an <a> element and set attributes for downloading
      const link = document.createElement('a');
      link.href = url;

      // Extract filename from URL if possible or set a default filename
      const filename = videoURL.substring(videoURL.lastIndexOf('/') + 1) || 'video.mp4';
      link.setAttribute('download', filename);

      // Append the link to the body, trigger the download, and clean up
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Revoke the object URL to free up memory
      window.URL.revokeObjectURL(url);
      showToast("success", "Successfully video downloaded");


    } catch (error) {
      console.error('Error downloading the video, falling back to new tab:', error);
      window.open(videoURL, "_blank");
      showToast("info", "Video opened in a new tab for download");
    }
    setLoading(false)
  };

  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification mb_40 ">
        <div className="login_inner">
          <h1 className="mb_30 main_title ">Work</h1>
          <p className="mb_40 them_para text-center mx-auto text_limit">
            The following orders are assigned to you.Please complete the pending
            orders before due date.
          </p>
          <div className="table_vedio_upload container-fluid mt_40 mb_30 h_400" style={{ maxWidth: "100%", width: "100%" }}>
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th scope="col" className="pl_25 font-weight-bold" style={{ minWidth: "175px" }}>
                    Video
                  </th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "80px" }}>F.Name</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "100px" }}>L.Name</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "100px" }}>Stroke Type</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "80px" }}>Team</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "80px" }}>Group</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "120px" }}>Package</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "80px" }}>Duration</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "70px" }}>Price</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "90px" }}>Status</th>
                  <th scope="col" className="font-weight-bold" style={{ minWidth: "110px" }}>Due By</th>
                  <th scope="col" className="text-center font-weight-bold" style={{ minWidth: "120px" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="overflow_custom">
                {loading ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      marginTop: 40,
                      backgroundColor: "#ffffffc2",
                    }}
                  >
                    <SpinnerCircular size="7%" />
                  </div>
                ) : (
                  <>
                    {work?.map((item, key) => (
                      <tr key={key}>
                        <td className="pl_25" style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {item.firstCamera && (
                              <div style={{ display: "flex", alignItems: "center", height: "100px" }}>
                                <span style={{ marginRight: "15px", fontSize: "14px", color: "#333", wordBreak: "break-all" }}>
                                  Cam1
                                </span>
                                <Link to="/video" state={{ video: item.firstCamera, id: item.recording_id }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <video
                                      src={`${item.firstCamera}#t=0.1`}
                                      preload="metadata"
                                      muted
                                      playsInline
                                      style={{ width: 120, height: 100, display: "block" }}
                                    />
                                    <img
                                      src={polygon}
                                      alt=""
                                      style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 20,
                                        height: 20,
                                      }}
                                    />
                                  </div>
                                </Link>
                              </div>
                            )}
                            {item.firstCamera && item.secondCamera && (
                              <hr style={{ margin: "5px 0", borderTop: "1px solid #ddd", width: "100%" }} />
                            )}
                            {item.secondCamera && (
                              <div style={{ display: "flex", alignItems: "center", height: "100px" }}>
                                <span style={{ marginRight: "15px", fontSize: "14px", color: "#333", wordBreak: "break-all" }}>
                                  Cam2
                                </span>
                                <Link to="/video" state={{ video: item.secondCamera, id: item.recording_id }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <video
                                      src={`${item.secondCamera}#t=0.1`}
                                      preload="metadata"
                                      muted
                                      playsInline
                                      style={{ width: 120, height: 100, display: "block" }}
                                    />
                                    <img
                                      src={polygon}
                                      alt=""
                                      style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 20,
                                        height: 20,
                                      }}
                                    />
                                  </div>
                                </Link>
                              </div>
                            )}
                          </div>
                        </td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>{item.firstName}</td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>{item.lastName}</td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>{item.stroke}</td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>{item.teamName}</td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>{item.teamGroup}</td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px", minWidth: "150px" }} title={item.package}>
                          <div style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "140px"
                          }}>
                            {item.package}
                          </div>
                        </td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>
                          <strong>{parseFloat(item.duration).toFixed(2)} m</strong>
                        </td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>${item.price}</td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>{item.status}</td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>{moment.utc(item.due_date).format('MMM Do, YYYY')}</td>
                        <td style={{ borderBottom: "1px solid #ddd", verticalAlign: "middle", padding: "20px 12px" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {item.firstCamera && (
                              <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "100px", gap: "10px" }}>
                                <button
                                  onClick={() => downloadVideos(item.firstCamera)}
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1.5px solid #0f4e9b",
                                    backgroundColor: "#0f4e9b",
                                    color: "#fff",
                                    cursor: "pointer",
                                    padding: 0
                                  }}
                                  title="Download Video"
                                >
                                  <FaDownload size={14} />
                                </button>
                                {item.evo_path !== null ? (
                                  <button
                                    disabled
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      border: "1.5px solid #ccc",
                                      backgroundColor: "#ccc",
                                      color: "#fff",
                                      cursor: "not-allowed",
                                      padding: 0
                                    }}
                                    title="Upload Completed"
                                  >
                                    <FaUpload size={14} />
                                  </button>
                                ) : (
                                  <Link
                                    to="/uploadYourWorkHere"
                                    state={{ id: item.id, camera: "cam1" }}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <button
                                      style={{
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "50%",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "1.5px solid #0f4e9b",
                                        backgroundColor: "#0f4e9b",
                                        color: "#fff",
                                        cursor: "pointer",
                                        padding: 0
                                      }}
                                      title="Upload Work"
                                    >
                                      <FaUpload size={14} />
                                    </button>
                                  </Link>
                                )}
                              </div>
                            )}
                            {item.firstCamera && item.secondCamera && (
                              <hr style={{ margin: "5px 0", borderTop: "1px solid #ddd", width: "100%" }} />
                            )}
                            {item.secondCamera && (
                              <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "100px", gap: "10px" }}>
                                <button
                                  onClick={() => downloadVideos(item.secondCamera)}
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1.5px solid #0f4e9b",
                                    backgroundColor: "#0f4e9b",
                                    color: "#fff",
                                    cursor: "pointer",
                                    padding: 0
                                  }}
                                  title="Download Video"
                                >
                                  <FaDownload size={14} />
                                </button>
                                {item.second_video_evo_path !== null ? (
                                  <button
                                    disabled
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      border: "1.5px solid #ccc",
                                      backgroundColor: "#ccc",
                                      color: "#fff",
                                      cursor: "not-allowed",
                                      padding: 0
                                    }}
                                    title="Upload Completed"
                                  >
                                    <FaUpload size={14} />
                                  </button>
                                ) : (
                                  <Link
                                    to="/uploadYourWorkHere"
                                    state={{ id: item.id, camera: "cam2" }}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <button
                                      style={{
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "50%",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "1.5px solid #0f4e9b",
                                        backgroundColor: "#0f4e9b",
                                        color: "#fff",
                                        cursor: "pointer",
                                        padding: 0
                                      }}
                                      title="Upload Work"
                                    >
                                      <FaUpload size={14} />
                                    </button>
                                  </Link>
                                )}
                              </div>
                            )}
                          </div>
                          {/* <div className="btn_wraper d-flex justify-content-center ">
                      <DownloadLink
                        style={{}}
                        className="them_btn"
                        label="Download"
                        filename={item.firstCamera}
                        exportFile={() => "My cached data"}
                      />
                       <Link to="">
                        <button type="button" className="them_btn ">
                          Donloading...
                        </button>
                      </Link> 
                    </div> */}
                        </td>
                        {/* <td>
                          {item.status === "Completed" ? (
                            <>
                              <div className="btn_wraper d-flex justify-content-center ">
                                <button
                                  className="them_btn"
                                  type="button"
                                  disabled
                                >
                                  Upload
                                </button>
                              </div>
                            </>
                          ) : (
                            <div className="btn_wraper d-flex justify-content-center ">
                              <Link
                                to="/uploadYourWorkHere"
                                state={{ id: item.id }}
                              >
                                <button
                                  type="button"
                                  className="them_btn "
                                // onClick={handleShow}
                                >
                                  Upload
                                </button>
                              </Link>
                            </div>
                          )}
                        </td> */}
                        {/* <td>
                          <div className="dropdown wraper_btn">
                            <Dropdown>
                              <Dropdown.Toggle
                                className="btn dropdown-toggle"
                                variant="success"
                                id="dropdown-basic"
                              >
                                <img
                                  src={dots}
                                  className="img-fulid"
                                  alt="dropdown"
                                />
                              </Dropdown.Toggle>

                              <Dropdown.Menu as="ul" className="dropul">
                                <Dropdown.Item as="li" onClick={() =>
                                  WatchVideoCode(item.id, "order_pending")
                                }>

                                  Show video

                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td> */}
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Modal show={showModal} onHide={handleClose}>
          {/* <Modal.Title></Modal.Title> */}

          <Modal.Body>
            <>
              <div className="modal-body">
                <input
                  onChange={(e) => {
                    setInputText(e.target.value);
                  }}
                  placeholder="Enter Text"
                />

                <input
                  type="file"
                  name="myfile"
                  style={{ marginTop: 20 }}
                  onChange={handleChanges}
                />

                <div className="modal-footer border-top-0">
                  {" "}
                  <button
                    type="button"
                    className="them_btn_ouline "
                    onClick={handleClose}
                  >
                    Cancel
                  </button>{" "}
                  <button
                    type="button"
                    className="them_btn "
                    onClick={handleUpload}
                  >
                    Upload Video
                  </button>
                </div>
                <h5 style={{ color: "green" }}>{message}</h5>
                <h5 style={{ color: "red" }}>{error}</h5>
              </div>
            </>
          </Modal.Body>
        </Modal>
      </section>
      <ToastContainer />
    </>
  );
}

export default Work;
